import React, { useEffect } from "react";

export function ReadonlyStringWidget(props) {
  const { data, ui, config } = props;
  const widgetId = ui.id;

  let isBold = config ? config.Bold : false;
  let alignRight = config ? config.AllignToRight : false;
  let content = data && data.content ? data.content : "";

  useEffect(() => {
    //console.log("ReadonlyStringWidget data of " + ui.id + ": ", data);
  }, [data]);

  const stringStyle = {
    textAlign: alignRight ? "right" : "inherit",
    fontWeight: isBold ? "bolder" : "inherit",
    lineHeight: ui.controlHeight + "em"
  }

  return (
    <div id={widgetId} style={stringStyle}>
      {content}
    </div>
  );
}
